

























































import { defineComponent, ref, computed, watch } from "@vue/composition-api";
import { useConfigStore } from "~/stores/extensionApi";

export default defineComponent({
  name: "ProductService",
  setup() {
    const configStore = useConfigStore();
    const freeShipValue = ref(null);

    const configs = computed(() => configStore.getConfigs);

    watch(
      configs,
      (newConfigs) => {
        if (newConfigs && newConfigs.free_ship_value !== undefined) {
          freeShipValue.value = newConfigs.free_ship_value;
        }
      },
      { immediate: true }
    );
    
    return {
      freeShipValue,
    };
  },
});
